import * as signalR from '@aspnet/signalr'
import store from '@/plugins/store/index.js'

const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.VUE_APP_MAIN_API}intaliohub`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => {
            return store.getters['user/token']
        },
    }).build()
if (connection) {
    connection.start().catch((err) => {
        console.log(err)
    })
}

export { connection }

